// Bootstrap Constants
export const BOOTSTRAP_INIT = '[BOOTSTRAP] BOOTSTRAP_INIT';
export const BOOTSTRAP_COMPLETE = '[BOOTSTRAP] BOOTSTRAP_COMPLETE';

// import data
import localisationData from '../../../assets/localisation.json';
import cards from '../../../assets/cards.json';
import { combinedMetadata } from '../../../assets/metadata.js';

// import actions
import { startFrontend, setLocalisation, setMetadata } from 'js/store/app/App.actions';
import { setCardData } from 'js/store/cards/Cards.actions';

export const startBootstrap = () => async (dispatch, getState) => {
  dispatch(setLocalisation(localisationData));
  dispatch(completeBootstrap());
  dispatch(setCardData(cards));

  dispatch(setMetadata(combinedMetadata));
};

export const completeBootstrap = () => {
  return (dispatch, getState) => {
    dispatch(startFrontend());
  };
};
